<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>
      <div>
        <StreamPreview
          :hls_stream_url="detailData.hls_stream_url"
          @addNewSteam="addNewSteam"
        />

        <StreamCard :item="detailData" class="mt-5" />

        <PublishLinks
          class="mt-5 mb-5"
          v-if="publishLinkItems && publishLinkItems.length > 0"
          :publishLinkItems="publishLinkItems"
          @reloadPublishLinks="getPublishLinkItems"
        />
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'

export default {
  name: 'StreamingDetail',
  data() {
    return {
      loading: false,
      detailData: {},
      publishLinkItems: [],
    }
  },
  created() {
    this.getDetail()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'servers.streaming',
        route: '/services/streaming',
      },
    ])
  },
  methods: {
    getDetail() {
      this.loading = true
      this.getDetailInfo()
        .then((res) => {
          this.setDetailInfo(res)
        })
        .catch(() => {
          this.redirectList()
        })
    },
    getDetailInfo() {
      return new Promise((resolve, reject) => {
        ApiService.get(`streaming/stream/${this.$route.params.id}`)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    redirectList() {
      this.$router.push('/services/streaming')
    },
    setDetailInfo(res) {
      if (res && res.data) {
        this.detailData = res.data
        // this.detailData.hls_stream_url =
        //   'https://austchannel-live.akamaized.net/hls/live/2002736/austchannel-sport/master.m3u8'
        this.getPublishLinkItems()
        this.loading = false
        this.setCustomHeaderParams()
      } else {
        this.redirectList()
      }
    },
    setCustomHeaderParams() {
      this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
        menuList: [
          {
            title: 'global.services',
          },
          {
            title: 'servers.streaming',
            route: '/services/streaming',
          },
          { title: 'global.detail' },
        ],
        showSearch: false,
        showDetailButton: false,
        statusLabel: this.detailData.status,
      })
    },
    addNewSteam(payload) {
      this.publishLinkItems.push({
        id: 'new',
        social_type: payload,
        name: '',
        key: '',
        url: '',
      })
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight)
      }, 100)
    },
    getPublishLinkItems() {
      this.loading = true
      this.publishLinkItems = []
      this.getPublishLinks()
        .then((res) => {
          if (res && res.data) {
            let tempLinks = res.data
            tempLinks.forEach((element) => {
              element.key = this.getStreamKey(element.url)
              element.url = element.url.replace(`/${element.key}`, '')
            })
            this.publishLinkItems = tempLinks
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getPublishLinks() {
      return new Promise((resolve, reject) => {
        ApiService.get(`streaming/stream/${this.$route.params.id}/endpoint`)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getStreamKey(stream_url) {
      if (stream_url) {
        let splt = stream_url.split('/')
        if (splt.length > 1) {
          return splt[splt.length - 1]
        }
      }
      return ''
    },
  },
  components: {
    StreamPreview: () => import('@/components/stream/StreamPreview'),
    StreamCard: () => import('@/components/stream/StreamCard'),
    PublishLinks: () => import('@/components/stream/PublishLinks'),
  },
}
</script>
